<header class="absolute top-0 left-0 right-0 flex justify-between items-center p-2 sm:p-3 md:p-4 border-b border-gray-200 shadow-md">
    <div>
        <img src="assets/images/salesforce-logo.png" class="h-8 sm:h-10 md:h-12 cursor-pointer" alt="Prudential Logo" (click)="goToLanding()" />
    </div>
    <div class="flex items-center">
        <button class="home-btn flex items-center justify-center text-gray-700 mr-2 sm:mr-4 min-h-[44px] min-w-[44px]" (click)="goHome()">
            <ng-icon name="ionHomeOutline" class="text-lg sm:text-xl md:text-2xl" />
        </button>
        <app-language-switcher textClass="text-gray-700"></app-language-switcher>
    </div>
</header>